function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import hasInterface from '../../../../../hasInterface';
import IllegalArgumentException from '../../../../../java/lang/IllegalArgumentException';
import ItemVisitor from '../../index/ItemVisitor';
import PointOnGeometryLocator from './PointOnGeometryLocator';
import LinearRing from '../../geom/LinearRing';
import SortedPackedIntervalRTree from '../../index/intervalrtree/SortedPackedIntervalRTree';
import LineSegment from '../../geom/LineSegment';
import Polygonal from '../../geom/Polygonal';
import LinearComponentExtracter from '../../geom/util/LinearComponentExtracter';
import ArrayListVisitor from '../../index/ArrayListVisitor';
import RayCrossingCounter from '../RayCrossingCounter';
var IndexedPointInAreaLocator = /*#__PURE__*/function () {
  function IndexedPointInAreaLocator() {
    _classCallCheck(this, IndexedPointInAreaLocator);
    IndexedPointInAreaLocator.constructor_.apply(this, arguments);
  }
  return _createClass(IndexedPointInAreaLocator, [{
    key: "locate",
    value: function locate(p) {
      var rcc = new RayCrossingCounter(p);
      var visitor = new SegmentVisitor(rcc);
      this._index.query(p.y, p.y, visitor);
      return rcc.getLocation();
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return IndexedPointInAreaLocator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [PointOnGeometryLocator];
    }
  }]);
}();
export { IndexedPointInAreaLocator as default };
var SegmentVisitor = /*#__PURE__*/function () {
  function SegmentVisitor() {
    _classCallCheck(this, SegmentVisitor);
    SegmentVisitor.constructor_.apply(this, arguments);
  }
  return _createClass(SegmentVisitor, [{
    key: "visitItem",
    value: function visitItem(item) {
      var seg = item;
      this._counter.countSegment(seg.getCoordinate(0), seg.getCoordinate(1));
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SegmentVisitor;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [ItemVisitor];
    }
  }]);
}();
SegmentVisitor.constructor_ = function () {
  this._counter = null;
  var counter = arguments[0];
  this._counter = counter;
};
var IntervalIndexedGeometry = /*#__PURE__*/function () {
  function IntervalIndexedGeometry() {
    _classCallCheck(this, IntervalIndexedGeometry);
    IntervalIndexedGeometry.constructor_.apply(this, arguments);
  }
  return _createClass(IntervalIndexedGeometry, [{
    key: "init",
    value: function init(geom) {
      var lines = LinearComponentExtracter.getLines(geom);
      for (var i = lines.iterator(); i.hasNext();) {
        var line = i.next();
        var pts = line.getCoordinates();
        this.addLine(pts);
      }
    }
  }, {
    key: "addLine",
    value: function addLine(pts) {
      for (var i = 1; i < pts.length; i++) {
        var seg = new LineSegment(pts[i - 1], pts[i]);
        var min = Math.min(seg.p0.y, seg.p1.y);
        var max = Math.max(seg.p0.y, seg.p1.y);
        this._index.insert(min, max, seg);
      }
    }
  }, {
    key: "query",
    value: function query() {
      if (arguments.length === 2) {
        var min = arguments[0];
        var max = arguments[1];
        var visitor = new ArrayListVisitor();
        this._index.query(min, max, visitor);
        return visitor.getItems();
      } else if (arguments.length === 3) {
        var _min = arguments[0];
        var _max = arguments[1];
        var _visitor = arguments[2];
        this._index.query(_min, _max, _visitor);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return IntervalIndexedGeometry;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
IntervalIndexedGeometry.constructor_ = function () {
  this._index = new SortedPackedIntervalRTree();
  var geom = arguments[0];
  this.init(geom);
};
IndexedPointInAreaLocator.SegmentVisitor = SegmentVisitor;
IndexedPointInAreaLocator.IntervalIndexedGeometry = IntervalIndexedGeometry;
IndexedPointInAreaLocator.constructor_ = function () {
  this._index = null;
  var g = arguments[0];
  if (!(hasInterface(g, Polygonal) || g instanceof LinearRing)) throw new IllegalArgumentException('Argument must be Polygonal or LinearRing');
  this._index = new IntervalIndexedGeometry(g);
};